(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/validated/components/card.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/validated/components/card.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  Image
} = svs.content.image_v2;
const {
  Card
} = svs.ui.ReactCard;
const {
  ReactButton: Button
} = svs.ui;
setGlobal('svs.ticketsValidate.pages.validated.components.Card', _ref => {
  let {
    title,
    preamble,
    buttonLabel,
    image,
    className = '',
    onBuyPhysicalTickets
  } = _ref;
  return React.createElement(Card, {
    className: "".concat(className, " tickets-card-grid f-body")
  }, React.createElement("div", {
    className: "u-flex u-flex-column padding-h-1 padding-top-2"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center w100"
  }, React.createElement("h4", {
    className: "h4 f-500 margin-bottom-1 tickets-validate-card-title"
  }, title)), React.createElement("div", {
    className: "tickets-card-body-grid w100 padding-1"
  }, React.createElement("p", {
    className: "p u-text-left"
  }, preamble), React.createElement("div", {
    className: "tickets-validate-card-image"
  }, image && React.createElement(Image, {
    image: _objectSpread({}, image)
  }))), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: () => onBuyPhysicalTickets('B'),
    transparent: true,
    type: "button"
  }, buttonLabel)));
});

 })(window);